<script lang="ts">
  import { getContext } from "svelte";

  import { shortAddress } from "../../helpers/string";
  import {
    connectBrowserSigner,
    ethereum,
  } from "../../store/ethereum";
  import ConnectModal from "../modals/ConnectModal.svelte";
  import { clearWallet } from "../../store/ethereum";

  let loading = false;
  $: connected = $ethereum.signer != undefined;
  export let style = "";
  const {open} = getContext("simple-modal")

  const connect = () => {
    if (connected) return (location.href = "/wallet");
    open(ConnectModal, { message: "Please Select a wallet provider" });
  };
  const disconnect = () => {
    clearWallet();
    location.href = "/";
  };
</script>

<button disabled={connected} on:click={connect} class="action connect_btn" {style}>  
  <span class="text">
    {#if connected}
      {shortAddress($ethereum.address)}
    {:else}
      Connect Wallet
    {/if}
  </span>
</button>
{#if connected}
<button disabled={loading} on:click={disconnect} class="ms-md-2 mt-md-0 mt-2 action connect_btn" {style}>  
  <span class="text">
    Disconnect Wallet
  </span>
</button>
{/if}

<style>
  .text {
    margin-left: 8px;
  }

  button:disabled,
  button:disabled:hover {
    color: initial;
    cursor: default;
    opacity: 1;
  }
   .connect_btn{
  background-color: #93cdbf;
  color: #212336;
  padding: 10px 50px;
  border: none;
  height: 38px;
  font-size: 11px;  
  font-weight: 600;
  text-decoration: none;
  max-width:250px;
}

 .connect_btn:hover{
  background-color: #ffa853;
}
</style>
